export const MenuArrowSquare = ({ style, className }) => {
    return (
      <svg
        style={style}
        className={className}
        width="16" 
        height="16" 
        viewBox="0 0 16 16"
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M10.7941 14.1597L10.7927 14.1597L5.20601 14.1597C4.09212 14.1597 3.26303 13.8296 2.7129 13.2795C2.16278 12.7293 1.83268 11.9002 1.83268 10.7863L1.83268 5.20634C1.83268 4.09245 2.16276 3.26351 2.71351 2.71345C3.26434 2.16332 4.09509 1.83301 5.21268 1.83301L10.7927 1.83301C11.9066 1.83301 12.7357 2.1631 13.2858 2.71323C13.8359 3.26335 14.166 4.09244 14.166 5.20634L14.166 10.793C14.166 11.907 13.8359 12.7359 13.286 13.2851C12.7363 13.8341 11.9076 14.1627 10.7941 14.1597Z"/>
        <path d="M5.14656 7.16044C5.14656 7.03378 5.19323 6.90711 5.29323 6.80711C5.48656 6.61378 5.80656 6.61378 5.9999 6.80711L7.9999 8.80711L9.9999 6.80711C10.1932 6.61378 10.5132 6.61378 10.7066 6.80711C10.8999 7.00044 10.8999 7.32044 10.7066 7.51378L8.35323 9.86711C8.1599 10.0604 7.8399 10.0604 7.64656 9.86711L5.29323 7.51378C5.19323 7.41378 5.14656 7.28711 5.14656 7.16044Z"/>
      </svg>
    );
  };